import React from 'react';
import AppShell from '../../components/app-shell/app-shell';
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import PickAClass from '../../components/landing-pages/pick-a-class';
import markdown from './pick-a-class.md';

export default function() {
  return (
    <AppShell
      seoTitle="Pick a Class"
      description="Don't know where to start? No problem! We'll help you pick your first class."
    >
      <PublicShell>
        <PickAClass />
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
